
export default function ThreeTierExplainer() {
  const tiers = [
    {
      name: 'Everyday',
      subtitle: 'General purpose bonding',
      description: 'For standard plastering and screed applications',
      color: '#F2C612',
      textColor: '#1A1A1A',
      features: [
        'Improves adhesion',
        'Reduces shrinkage',
        'Interior use',
        'Easy to apply',
        'Dilutable',
      ],
    },
    {
      name: 'Contractor Grade',
      subtitle: 'Enhanced bonding for demanding jobs',
      description: 'Professional-grade performance for challenging applications',
      color: '#2D7AC2',
      textColor: '#FFFFFF',
      features: [
        'Superior adhesion',
        'Interior and exterior',
        'Faster bonding',
        'Weather resistant',
        'Wide application range',
      ],
    },
    {
      name: 'Elite Pro Series',
      subtitle: 'Maximum bonding strength',
      description: 'Ultimate performance for critical structural work',
      color: '#D42B2B',
      textColor: '#FFFFFF',
      features: [
        'Extreme adhesion',
        'Structural applications',
        'Rapid setting',
        'Waterproof',
        'Commercial grade',
      ],
    },
  ];

  return (
    <section className="py-16 md:py-24 px-4 md:px-8 bg-gray-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-3xl md:text-4xl font-bold mb-4 text-gray-900" style={{ fontFamily: 'Montserrat, sans-serif' }}>
            Choose Your Grade
          </h2>
          <p className="text-lg md:text-xl text-gray-600 max-w-3xl mx-auto">
            Because not every job is the same. Our three-tier system lets you choose the right product for your project and budget.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {tiers.map((tier) => (
            <div
              key={tier.name}
              className="rounded-xl p-8 flex flex-col"
              style={{ backgroundColor: tier.color }}
            >
              <h3
                className="text-2xl font-extrabold mb-1"
                style={{ fontFamily: 'Montserrat, sans-serif', color: tier.textColor }}
              >
                {tier.name}
              </h3>
              <p className="text-sm font-semibold mb-1" style={{ color: tier.textColor, opacity: 0.9 }}>
                {tier.subtitle}
              </p>
              <p className="text-sm mb-6" style={{ color: tier.textColor, opacity: 0.8 }}>
                {tier.description}
              </p>
              <ul className="flex flex-col gap-3">
                {tier.features.map((feature) => (
                  <li key={feature} className="flex items-center gap-3">
                    <span className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                      <i className="ri-check-line text-lg font-bold" style={{ color: tier.textColor }}></i>
                    </span>
                    <span className="text-sm font-medium" style={{ color: tier.textColor }}>
                      {feature}
                    </span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
